import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import trimStart from 'lodash/trimStart';
import { isValidChange } from './helpers';
import { removeUnallowedCharsFromString } from 'helpers/validate';
import { GeneralDialog, GeneralInput } from 'sharedComponents';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { apiCallStatus, MAX_ASSET_NAME_LENGTH } from 'helpers/constants';
import { reNameStatus } from './constants';

import './style.scss';


const RenameAssetComponent = (props) => {
    const { t: translate } = useTranslation();
    const { model: { assetUpdateStatus } } = props;
    const [assetName, setAssetName] = useState(props.asset?.name);
    const [specialCharError, setSpecialCharError] = useState('');
    const [lengthError, setLengthError] = useState('');
    const oldassetName = props.asset?.name;

    const onNameChange = (value) => {
        const trimmedAssetName = trimStart(value);
        const hasSpecialCharsInName = removeUnallowedCharsFromString(trimmedAssetName) !== trimmedAssetName;
        const correctedAssetName = hasSpecialCharsInName
            ? removeUnallowedCharsFromString(trimmedAssetName) ?? trimmedAssetName
            : trimmedAssetName;

        setAssetName(correctedAssetName);
        setSpecialCharError(hasSpecialCharsInName ? translate('ABB.Powertrain.Frontend.assetInfoassetNameSpecialChars') : '');
        setLengthError(correctedAssetName.trim().length > MAX_ASSET_NAME_LENGTH ? translate('ABB.Powertrain.Frontend.assetInfoassetNameValidation') : '');
    };

    const onClose = () => {
        setAssetName(props.asset?.name);
        setSpecialCharError('');
        setLengthError('');
        props.close();
    };

    const onSave = () => {
        const asset = { ...props.asset, name: assetName, eTag: oldassetName };
        props.actions.updateAsset(asset);
    };

    useEffect(() => {
        if (props?.model?.assetRenameStatus === reNameStatus.reNameAsset) {
            onClose();
        }
    }, [props?.model?.assetRenameStatus]);
    return <GeneralDialog
        id='rename-modal'
        show={props.show}
        save={onSave}
        close={onClose}
        title={props.title}
        closeButton={assetUpdateStatus !== apiCallStatus.LOADING}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.componentRenameModalCancel'),
            onClick: () => { onClose(); },
            disabled: assetUpdateStatus === apiCallStatus.LOADING
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.componentRenameModalSave'),
            onClick: () => { onSave(); },
            disabled: !isValidChange(assetName, props.asset?.name) ||
                assetUpdateStatus === apiCallStatus.LOADING || !!lengthError
        }}
    >
        <Container className='rename-modal-container g-0'>
            <LoadingStatusWrapper loadingStatus={assetUpdateStatus} hideError >
                <Row className='asset-name-label'><span>{translate('ABB.Powertrain.Frontend.assetNameLabel')}</span></Row>
                <Row>
                    <GeneralInput
                        id='renameComponent'
                        type='text'
                        value={assetName}
                        placeholder={translate('ABB.Powertrain.Frontend.componentRenameModalPlaceholder')}
                        onChange={(e) => { onNameChange(e); }}
                    />
                </Row>
                {specialCharError && <Row className='asset-name-error'><span className='text-danger'>{specialCharError}</span></Row>}
                {lengthError && <Row className='asset-name-error'><span className='text-danger'>{lengthError}</span></Row>}
            </LoadingStatusWrapper>
        </Container>
    </GeneralDialog>;
};
RenameAssetComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    title: PropTypes.string,
    asset: PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string
    }),
    actions: PropTypes.shape({
        updateAsset: PropTypes.func
    }),
    model: PropTypes.shape({
        assetRenameStatus: PropTypes.string
    })
};

export default RenameAssetComponent;
